module.exports = __webpack_public_path__ + "img/defender-robot-mask.9da2af54.png";